import { freigabeWarningDialogContent } from '../../../components/general/freigabeWarningDialogContent.ts';

export const content = {
  buttons: {
    loeschen: 'Löschen',
    inPlanung: 'Auf "In Planung" setzen',
    imAusschreibungsportal: 'In Ausschreibung übertragen',
    abgeschlossen: 'Auf "Planung abgeschlossen" setzen',
    freigegeben: 'Auf "Planung freigegeben" setzen',
  },
  deleteDialog: {
    title: 'Veranstaltung(en) löschen',
    content: 'Diese Veranstaltung(en) wird gelöscht. Dies kann nicht rückgängig gemacht werden.',
  },
  freigabeWarningDialog: freigabeWarningDialogContent,
  keineVeranstaltungenAuswahl: 'Keine Veranstaltungen ausgewählt.',
  keineVeranstaltungenAenderung: 'Keine Veranstaltungen geändert.',
  keineEindeutigeTerminanfrage:
    'Es gibt keine eindeutige Terminanfrage für diese Veranstaltung. Bitte prüfe auf der Veranstaltungsdetailseite die Blockungs- und Terminanfragedetails.',
  deleteVeranstaltungenError: 'Bei dem Versuch, die Veranstaltung(en) zu löschen, trat ein Fehler auf.',
} as const;
